import { Injectable } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { LoyaltyEndpoint } from '@app/services/loyalty/loyalty-endpoints.service';
import { TransactionFilterModel } from '@app/models/Transaction-Filter-model';

@Injectable()
export class LoyaltyService {
    constructor(private router: Router, private http: Http, private loyaltyEndpoint: LoyaltyEndpoint) {
    }
    getLoyalty(trans: TransactionFilterModel) {
      
        return this.loyaltyEndpoint.getLoyalty(trans);
    }
    getLoyaltyPdfExcel(trans: TransactionFilterModel) {
      
        return this.loyaltyEndpoint.getLoyaltyPdfExcel(trans);
    }

}


// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty.service.ts